import type { JDSMobileBottomSheetInternalProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSMobileBottomSheetInternalProps>
  ): React.FC<JDSMobileBottomSheetInternalProps> =>
  (props: JDSMobileBottomSheetInternalProps) => {
    return (
      <Component
        {...{
          ...props,
          _ariaModal:
            props.kind === 'overlay' || !props.close ? 'true' : 'false'
        }}
      />
    );
  };
